import Base from './Base';
import Parse from 'parse';

export default class DeliveryAddress extends Base {
  constructor(parseObject) {
    super();
    if (!parseObject) parseObject = new Parse.Object('DeliveryAddress');
    this.setParseObject(parseObject);

    /**
     * @lends DeliveryAddress.prototype
     */
    this._init({
      contactPerson: '',
      company: '',
      street: '',
      streetAdditonal: '',
      zipCode: '',
      city: '',
      country: '',
    });
    this.setAttributes(parseObject.toJSON());
  }

  fullAddress() {
    return `${this.country}-${this.zipCode} ${this.city}, ${this.street} ${this.streetAdditonal} <br> <b>${this.contactPerson}</b> <br> <b>${this.company}</b>`;
  }

  static collection(parseObjects) {
    return parseObjects.map((el) => new DeliveryAddress(el));
  }
}
